import RecoverStep from "./recover_step";
import {showVmsList} from "../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../utils/recover_consts";

const TEMPLATE = 'virtualization-start-vm';

export default class StartVm extends RecoverStep {

    constructor() {
        super(TEMPLATE);
    }

    open(data, el, fr, previousStep) {
        const check_vm_state = function () {
            $.ajax({
                type: "POST",
                url: "/ra_ajax/is_vm_running",
                data: JSON.stringify({
                    aid: data.recovery.device.appliance_id,
                    schedule_asid: data.recovery.device.asid
                }),
                success: function (response) {
                    if (!$.contains(document.documentElement, fr.flowcontainer[0])) {
                        return;
                    }

                    if (response.is_error) {
                        data.render.hasError = true;
                        if (fr.flowcontainer.is(":visible")) {
                            fr.render();
                        }
                    } else if (response.data.started) {
                        fr.close();
                        showVmsList(data);
                    } else {
                        setTimeout(check_vm_state, 4000);
                    }
                },
                dataType: AJAX_DATA_TYPE_JSON,
                contentType: "application/json"
            }).fail(fr.defaultAJAXErrorHandler);
        };

        const requestSettings = data.recovery.config;
        requestSettings.aid = data.recovery.device.appliance_id;
        requestSettings.schedule_asid = data.recovery.device.asid;

        $.ajax({
            type: "POST",
            url: "/ra_ajax/create_start_"+data.recovery.virtualization.type,
            data: JSON.stringify(requestSettings),
            success: function (response) {
                if (response.is_error) {
                    show_alert(response.title, response.message, { dialogClass: 'axDialog rstyled' });
                    fr.close();
                    return;
                }
                setTimeout(check_vm_state, 4000);
            },
            dataType: AJAX_DATA_TYPE_JSON,
            contentType: "application/json"
        }).fail(fr.defaultAJAXErrorHandler);
    }


    transitionAnother(data, el, fr) {
        data.recovery = { type: 'virtualization', via: null, device_name: null, virtualization: null, restore: null };
        data.deviceId = null;
        fr.goTo('locateVirtualization');
    }

}
